// Homedek theme JS
document.addEventListener('DOMContentLoaded', function () {
  // Close mobile nav when a link is clicked
  document.querySelectorAll('.site-nav a').forEach(function (link) {
    link.addEventListener('click', function () {
      var nav = document.querySelector('.site-nav');
      if (nav) nav.classList.remove('mobile-open');
    });
  });

  // Touch-friendly category dropdown toggle (hover doesn't work on touch devices)
  document.querySelectorAll('.cat-dropdown > button').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      var menu = this.nextElementSibling;
      var isOpen = menu.style.display === 'block';
      document.querySelectorAll('.cat-menu').forEach(function (m) { m.style.display = 'none'; });
      menu.style.display = isOpen ? 'none' : 'block';
    });
  });
  document.addEventListener('click', function () {
    document.querySelectorAll('.cat-menu').forEach(function (m) { m.style.display = ''; });
  });
});
